export default __webpack_public_path__ + "static/media/chair.c3319eca.jpg";